module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-es.4a04173f3aa68f147769.svg";